import { IDepartments } from '@/schemas/doctor';
import * as services from '@services/index';

interface State {
  departmentId: number | null;
  departments: IDepartments;
  sortRules: IDepartments;
  filterRules: any;
  recommendDepartmentList: any;
  departmentList: any;
}

const initState: State = {
  departmentId: null,
  departments: [],
  sortRules: [],
  filterRules: [],
  recommendDepartmentList: [],
  departmentList: []
};

const doctors = {
  state: initState,

  reducers: {
    updateState(state: State, payload) {
      return {
        ...state,
        ...payload
      };
    },

    updateDepartmentId(state, departmentId) {
      return {
        ...state,
        departmentId
      };
    }
  },

  effects: (_dispatch) => ({
    async getDepartments() {
      try {
        const result = await services.doctors.getDepartment();

        this.updateState({
          departments: result
        });
      } catch (error) {
        Promise.reject(error);
      }
    },

    async getListSortRule() {
      try {
        const result = await services.doctors.getListSortRule();
        this.updateState({
          sortRules: result
        });
      } catch (error) {
        Promise.reject(error);
      }
    },

    async getFilterRule() {
      try {
        const result = await services.doctors.getFilterRule();
        this.updateState({
          filterRules: result
        });
      } catch (error) {
        Promise.reject(error);
      }
    },

    async getFilterDepartmentList() {
      try {
        const result = await services.doctors.getFilterDepartmentList();
        this.updateState({
          departmentList: result
        });
      } catch (error) {
        Promise.reject(error);
      }
    },

    async getRecommentdDepartmentList() {
      try {
        const result = await services.doctors.getRecommendDepartmentList();
        this.updateState({
          recommendDepartmentList: result
        });
      } catch (error) {
        Promise.reject(error);
      }
    }
  })
};

export default doctors;
